module.exports = __webpack_public_path__ + "static/img/icon-6.bce15fdc.png";